type BrowserName =
  | "chrome"
  | "firefox"
  | "safari"
  | "edge"
  | "opera"
  | "samsung"
  | "line"
  | "facebook"
  | "instagram"
  | "twitter"
  | "slack"
  | "unknown";

const BROWSER_PATTERNS: [RegExp, BrowserName][] = [
  [/chrome/i, "chrome"],
  [/firefox/i, "firefox"],
  [/safari/i, "safari"],
  [/edge/i, "edge"],
  [/opera/i, "opera"],
  [/samsung/i, "samsung"],
  [/line/i, "line"],
  [/facebook/i, "facebook"],
  [/instagram/i, "instagram"],
  [/twitter/i, "twitter"],
  [/slack/i, "slack"]
];

/* 利用ブラウザの名前を調整 */
export const extractionBrowserName = (browserName: string): BrowserName => {
  if (!browserName) return "unknown";

  const lowerBrowserName = browserName.toLowerCase();

  for (const [pattern, name] of BROWSER_PATTERNS) {
    if (pattern.test(lowerBrowserName)) {
      return name;
    }
  }

  return "unknown";
};

// export const browserColors = {
//   chrome: "border-[#f3b80b]",
//   firefox: "border-[#ff7139]",
//   safari: "border-[#007AFF]",
//   edge: "border-[#0078d7]",
//   opera: "border-[#FF1B2D]",
//   samsung: "border-[#1428a0]",
//   line: "border-[#00B900]",
//   facebook: "border-[#1877F2]",
//   instagram: "border-[#E4405F]",
//   twitter: "border-[#1DA1F2]",
//   slack: "border-[#4A154B]",
//   Unknown: ""
// } as { [key: string]: string };
